// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import { Sentry, isProduction } from "utils/sentry"

const application = Application.start()

// 設定全域錯誤處理器，捕捉 Stimulus controller 錯誤
// 在 production 環境自動回報到 Sentry（遵循 Stimulus 官方建議的整合方式）
const originalHandleError = application.handleError.bind(application)
application.handleError = (error, message, detail) => {
  // 在 production 環境回報到 Sentry
  if (isProduction && Sentry) {
    Sentry.withScope((scope) => {
      scope.setTag('error_source', 'stimulus')
      scope.setExtra('stimulus_message', message)

      // 附加 controller 資訊（如果有）
      if (detail?.identifier) {
        scope.setTag('stimulus_controller', detail.identifier)
      }
      if (detail?.element) {
        scope.setExtra('element_html', detail.element.outerHTML?.substring(0, 500))
      }

      Sentry.captureException(error)
    })
  }

  // 調用原始的錯誤處理器（console 輸出）
  originalHandleError(error, message, detail)
}

const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
